
const env = {
    env: process.env.REACT_APP_ENV,
    app: {
        port: 3000
    },
    urls: {
      graphql: process.env.REACT_APP_GRAPHQL_URL,
      assets: process.env.REACT_APP_ASSETS_URL,
      report: process.env.REACT_APP_REPORT_URL
    }
};

module.exports = env;
